/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { CustomModal } from 'src/components'
import { useTranslation } from 'next-i18next'
import { resetUserRegisterSuccessState } from 'src/features/users/slice.reducers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import RegisterUserForm from './RegisterUserForm/RegisterUserForm'

interface RegisterUserModalProps {
  isModalVisible: boolean
  setIsModalVisible: Function
  isOnlyOffsetter?: boolean
}

const RegisterUserModal: React.FC<RegisterUserModalProps> = (props) => {
  const { isModalVisible, setIsModalVisible, isOnlyOffsetter = false } = props
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { success } = useAppSelector((state) => state.users.registerUser)

  useEffect(() => {
    if (success) {
      setIsModalVisible(false)
      dispatch(resetUserRegisterSuccessState())
    }
  }, [success])

  return (
    <>
      <CustomModal
        title={t('admin.Brokerage.CreateUser')}
        footer={null}
        width={1000}
        maskClosable={false}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      >
        <RegisterUserForm isOnlyOffsetter={isOnlyOffsetter} />
      </CustomModal>
    </>
  )
}
export default RegisterUserModal
